import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DateRange as MsgDateRange } from '@shared/components/chitin/molecules/daterange-picker/date-range';
import { DataGridFilterChanged } from '@shared/components/data-grid/data-grid-events';
import { GridColumn } from '@shared/models/grid-column.model';

@Component({
  selector: 'app-data-grid-filter',
  templateUrl: './data-grid-filter.component.html',
  standalone: false,
})
export class DataGridFilterComponent {
  @Input() column?: GridColumn;
  @Input() value?: any;
  @Input() isLoading: boolean = false;
  @Output()
  filterChanged = new EventEmitter<DataGridFilterChanged>();

  filterChange(value: any, column: GridColumn) {
    this.filterChanged.next({ value, column });
  }

  dateRangeValueChange(value: MsgDateRange | undefined, column: GridColumn) {
    this.filterChange(
      value?.from && value?.to
        ? {
            from: value.from,
            to: value.to,
          }
        : undefined,
      column,
    );
  }
}
